import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ChartOfAccountsList } from '../components/ChartOfAccountsList';
import { ChartOfAccountsForm } from '../components/ChartOfAccountsForm';
import { ChartOfAccount } from '../types/chart-of-accounts.types';

export const ChartOfAccountsPage: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<ChartOfAccount | null>(null);
  const [formMode, setFormMode] = useState<'create' | 'edit'>('create');

  const handleAdd = () => {
    setSelectedAccount(null);
    setFormMode('create');
    setIsFormOpen(true);
  };

  const handleEdit = (account: ChartOfAccount) => {
    setSelectedAccount(account);
    setFormMode('edit');
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedAccount(null);
  };

  return (
    <Box>
      <ChartOfAccountsList
        onAdd={handleAdd}
        onEdit={handleEdit}
      />
      
      <ChartOfAccountsForm
        open={isFormOpen}
        onClose={handleCloseForm}
        account={selectedAccount}
        mode={formMode}
      />
    </Box>
  );
};
